import React, {memo} from 'react';

import {MarkdownTokensFormatter} from '../../../../../srcCommon/formatters/markdown/markdownTokensFormatter';
import {buildLinkifyTokens} from '../../../../services/markdown';
import {MarkdownTokenFormatter} from './markdownTokenFormatter';

/*
 * Props.
 */

interface LinkifyFormatterProps {
  text: string;
  onLinkClick?: (link: string, shiftKey?: boolean) => void;
}

/*
 * Component.
 */

export const LinkifyFormatter = memo<LinkifyFormatterProps>((props) => {
  // Build the linkified tokens for the provided text.
  const tokens = buildLinkifyTokens(props.text);

  // Render the tokens.
  return <MarkdownTokensFormatter {...props} formatter={MarkdownTokenFormatter} tokens={tokens} />;
});
